import React, { useState } from "react";
import s from "../../admin_styles/UserSearch.module.css";

export default function MassActions({ selectedUsers }) {
  const [showTgModal, setShowTgModal] = useState(false);
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const [tgError, setTgError] = useState("");
  const [tgResponse, setTgResponse] = useState(null);

  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailSubject, setEmailSubject] = useState("");
  const [emailBodyHtml, setEmailBodyHtml] = useState("");
  const [emailError, setEmailError] = useState("");
  const [emailResponse, setEmailResponse] = useState(null);
  const [emailPending, setEmailPending] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0] || null);
  };

  const maxLength = file ? 1024 : 4096;
  const currentLength = message.length;

  const handleSendTg = async () => {
    if (currentLength > maxLength) {
      setTgError(`Превышен лимит символов (${currentLength}/${maxLength})`);
      return;
    }

    setTgError("");

    const tgIds = selectedUsers.map((u) => u.tg_user_id).filter(Boolean);

    const formData = new FormData();
    formData.append("tg_ids", JSON.stringify(tgIds));
    formData.append("message", message);
    if (file) formData.append("photo", file);

    try {
      const res = await fetch("/api/admin/sms_to_users", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      setTgResponse(data);

      if (res.ok) {
        setMessage("");
        setFile(null);
        setTimeout(() => {
          setShowTgModal(false);
          setTgResponse(null);
        }, 2000);
      } else {
        setTgError(data.error || "Ошибка отправки");
      }
    } catch (err) {
      setTgError("Ошибка сети");
    }
  };

  const handleSendEmail = async () => {
    if (!emailSubject.trim()) {
      setEmailError("Укажите тему письма");
      return;
    }
    if (!emailBodyHtml.trim()) {
      setEmailError("Тело письма не может быть пустым");
      return;
    }

    setEmailError("");
    setEmailPending(true);

    const emails = selectedUsers.map((u) => u.login).filter(Boolean);

    try {
      const res = await fetch("/api/admin/email_to_users", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          emails,
          subject: emailSubject,
          body_html: emailBodyHtml,
        }),
      });

      const data = await res.json();
      setEmailResponse(data);

      if (res.ok) {
        setTimeout(() => {
          setShowEmailModal(false);
          setEmailResponse(null);
          setEmailSubject("");
          setEmailBodyHtml("");
        }, 3000);
      } else {
        setEmailError(data.error || "Ошибка отправки");
      }
    } catch (err) {
      setEmailError("Ошибка сети");
    } finally {
      setEmailPending(false);
    }
  };

  if (selectedUsers.length === 0) return null;

  return (
    <div className={s.massActions}>
      <button onClick={() => setShowTgModal(true)}>
        ✈️ Telegram ({selectedUsers.length})
      </button>

      <button onClick={() => setShowEmailModal(true)} style={{ marginLeft: "8px" }}>
        ✉️ Email ({selectedUsers.length})
      </button>

      {showTgModal && (
        <div className={s.modalOverlay}>
          <div className={s.modalContent}>
            <h3>Отправить Telegram-сообщение</h3>

            <textarea
              className={s.textareaFull}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Введите сообщение..."
            />

            <div style={{ textAlign: "right", fontSize: "0.85rem", marginTop: "4px" }}>
              {currentLength}/{maxLength} символов
            </div>

            <input
              className={s.fileInputFull}
              type="file"
              accept="image/*"
              onChange={handleFileChange}
            />

            {file && (
              <p className={s.fileName}>
                📷 Загружено: <b>{file.name}</b>
              </p>
            )}

            {tgError && (
              <p style={{ color: "red", fontSize: "0.85rem", marginTop: "4px" }}>
                {tgError}
              </p>
            )}

            {tgResponse && (
              <p
                style={{
                  color: tgResponse.status === "ok" ? "green" : "red",
                  fontSize: "0.85rem",
                  marginTop: "6px",
                }}
              >
                {tgResponse.status === "ok"
                  ? `✅ Сообщение отправлено ${tgResponse.sent} пользователям`
                  : `❌ Ошибка: ${tgResponse.error || "Не удалось отправить сообщение"}`}
              </p>
            )}

            <div className={s.modalActions}>
              <button onClick={handleSendTg}>Отправить</button>
              <button onClick={() => setShowTgModal(false)}>Отмена</button>
            </div>

            <div
              style={{
                fontSize: "0.9rem",
                background: "#f9fafb",
                padding: "8px",
                borderRadius: "6px",
                marginTop: "8px",
              }}
            >
              <p>
                <b>Допустимые теги:</b> &lt;b&gt;жирный&lt;/b&gt;, &lt;i&gt;курсив&lt;/i&gt;, &lt;u&gt;подчеркнутый&lt;/u&gt;, &lt;s&gt;зачеркнутый&lt;/s&gt;, &lt;a href="url"&gt;ссылка&lt;/a&gt;, &lt;code&gt;код&lt;/code&gt;, &lt;pre&gt;блок кода&lt;/pre&gt;.
              </p>
              <p>Перенос строки — нажатием Enter (не использовать &lt;br&gt; или \n).</p>
              <p>
                Максимум: <b>4096 символов</b> без фото, <b>1024</b> с фото.
              </p>
            </div>
          </div>
        </div>
      )}

      {showEmailModal && (
        <div className={s.modalOverlay}>
          <div className={s.modalContent}>
            <h3>Отправить Email</h3>
            <p style={{ fontSize: "0.85rem", color: "#555", marginBottom: "8px" }}>
              Получателей: <b>{selectedUsers.filter((u) => u.login).length}</b>
            </p>

            <input
              type="text"
              placeholder="Тема письма"
              value={emailSubject}
              onChange={(e) => setEmailSubject(e.target.value)}
              style={{
                width: "100%",
                boxSizing: "border-box",
                padding: "8px",
                marginBottom: "8px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                fontSize: "0.9rem",
              }}
            />

            <textarea
              className={s.textareaFull}
              value={emailBodyHtml}
              onChange={(e) => setEmailBodyHtml(e.target.value)}
              placeholder="HTML-тело письма (или обычный текст)..."
              rows={8}
            />

            {emailError && (
              <p style={{ color: "red", fontSize: "0.85rem", marginTop: "4px" }}>
                {emailError}
              </p>
            )}

            {emailResponse && (
              <p
                style={{
                  color: emailResponse.status === "ok" ? "green" : "red",
                  fontSize: "0.85rem",
                  marginTop: "6px",
                }}
              >
                {emailResponse.status === "ok"
                  ? `✅ Письма отправлены: ${emailResponse.sent}${emailResponse.errors?.length ? `, ошибок: ${emailResponse.errors.length}` : ""}`
                  : `❌ Ошибка: ${emailResponse.error || "Не удалось отправить"}`}
              </p>
            )}

            <div className={s.modalActions}>
              <button onClick={handleSendEmail} disabled={emailPending}>
                {emailPending ? "Отправляем..." : "Отправить"}
              </button>
              <button onClick={() => setShowEmailModal(false)}>Отмена</button>
            </div>

            <div
              style={{
                fontSize: "0.85rem",
                background: "#f9fafb",
                padding: "8px",
                borderRadius: "6px",
                marginTop: "8px",
              }}
            >
              <p>Принимается HTML. Письма отправляются через RuSender на адрес <b>login</b> каждого пользователя.</p>
              <p>Пользователи без email (или без login) пропускаются.</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
